/**
 * Tutorial Registry
 * Central export point for all tutorials.
 */

export { studioTutorial } from './studioTutorial';
export { homePageTutorial } from './homePageTutorial';
export { promptsPageTutorial } from './promptsPageTutorial';
export { filteringPromptsTutorial } from './filteringPromptsTutorial';

// Tutorial IDs for reference
export const TUTORIAL_IDS = {
  STUDIO_RECORDING: 'studio-recording',
  HOME_PAGE: 'home-page',
  PROMPTS_PAGE: 'prompts-page',
  FILTERING_PROMPTS: 'filtering-prompts'
};

// List of all available tutorials (for menu display)
// Each entry includes a `page` field indicating which page the tutorial should start on
export const ALL_TUTORIALS = [
  {
    id: 'studio-recording',
    label: 'Tutorial: How to use the Studio',
    tutorialKey: 'studioTutorial',
    page: 'prompts'
  },
  {
    id: 'home-page',
    label: 'Tutorial: Home page tour',
    tutorialKey: 'homePageTutorial',
    page: 'home'
  },
  {
    id: 'prompts-page',
    label: 'Tutorial: How to use prompts',
    tutorialKey: 'promptsPageTutorial',
    page: 'prompts'
  },
  {
    id: 'filtering-prompts',
    label: 'Tutorial: Filtering prompts',
    tutorialKey: 'filteringPromptsTutorial',
    page: 'prompts'
  }
];
